/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation paymentPaypalIpnReceive
   */
  static readonly PaymentPaypalIpnReceivePath = '/payment/ipn/paypal';

  /**
   * Receive paypal ipn notifications
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentPaypalIpnReceive()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentPaypalIpnReceive$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentPaypalIpnReceivePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Receive paypal ipn notifications
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paymentPaypalIpnReceive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentPaypalIpnReceive(params?: {
  }): Observable<void> {

    return this.paymentPaypalIpnReceive$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation paymentPaypalGenerate
   */
  static readonly PaymentPaypalGeneratePath = '/invoice/{uuid}/payment/paypal';

  /**
   * Generate a new paypal payment flow
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentPaypalGenerate()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentPaypalGenerate$Response(params: {

    /**
     * invoice uuid
     */
    uuid: string;

    /**
     * Invoice password
     */
    password: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentPaypalGeneratePath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
      rb.query('password', params.password, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Generate a new paypal payment flow
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paymentPaypalGenerate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentPaypalGenerate(params: {

    /**
     * invoice uuid
     */
    uuid: string;

    /**
     * Invoice password
     */
    password: string;
  }): Observable<void> {

    return this.paymentPaypalGenerate$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation paymentRedsysIpnReceive
   */
  static readonly PaymentRedsysIpnReceivePath = '/payment/ipn/redsys';

  /**
   * Receive redsys ipn notifications
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentRedsysIpnReceive()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentRedsysIpnReceive$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentRedsysIpnReceivePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Receive redsys ipn notifications
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paymentRedsysIpnReceive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentRedsysIpnReceive(params?: {
  }): Observable<void> {

    return this.paymentRedsysIpnReceive$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation paymentRedsysGenerate
   */
  static readonly PaymentRedsysGeneratePath = '/invoice/{uuid}/payment/redsys';

  /**
   * Generate a new redsys payment flow
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentRedsysGenerate()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentRedsysGenerate$Response(params: {

    /**
     * invoice uuid
     */
    uuid: string;

    /**
     * Invoice password
     */
    password: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentRedsysGeneratePath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
      rb.query('password', params.password, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Generate a new redsys payment flow
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paymentRedsysGenerate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentRedsysGenerate(params: {

    /**
     * invoice uuid
     */
    uuid: string;

    /**
     * Invoice password
     */
    password: string;
  }): Observable<void> {

    return this.paymentRedsysGenerate$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
